const actions = {
    FETCH_MCW_SCHEDULE_LIST: 'FETCH_MCW_SCHEDULE_LIST',
    FETCH_MCW_SCHEDULE: 'FETCH_MCW_SCHEDULE',
    RESET_MCW_SCHEDULE_FORM: 'RESET_MCW_SCHEDULE_FORM',

    // Action for fetching the paginated list/filtered results
    fetchMCWScheduleListAction: (data) => {
        return {
            type: actions.FETCH_MCW_SCHEDULE_LIST,
            data: data
        };
    },

    // Action for resetting the form (useful when closing a modal or clearing state)
    resetMCWScheduleFormAction: () => {
        return {
            type: actions.RESET_MCW_SCHEDULE_FORM,
            data: null
        };
    },

    // Action for fetching single MCW details (useful for editing)
    fetchMCWScheduleAction: (data) => {
        return {
            type: actions.FETCH_MCW_SCHEDULE,
            data: data
        };
    },
};

export default actions;